import { useEffect, useState } from 'react';

export type Theme = 'light' | 'dark';
const KEY = 'casijud.theme';

function current(): Theme {
  return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
}

/** Mode jour / nuit : choix de l'utilisateur conservé, sinon préférence du système (appliquée par theme-init.js). */
export function useTheme(): [Theme, () => void] {
  const [theme, setTheme] = useState<Theme>(current);
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);
  const toggle = () => {
    const next: Theme = current() === 'dark' ? 'light' : 'dark';
    try {
      window.localStorage.setItem(KEY, next);
    } catch {
      // stockage indisponible : le choix vaut pour cette page
    }
    setTheme(next);
  };
  return [theme, toggle];
}
